<template>
  <component :is="way" v-bind="$attrs" v-on="$listeners" />
</template>

<script>
  import PROCESS_NAMES from '@/process/names';
  import SendButtonDefault from './default';
  const SendButtonSibur = () =>
    import(
      /* webpackChunkName: "sibur-test" */ '@/process/sibur-test/components/invites/creation/SendButton.vue'
    );

  export default {
    name: 'SendButtonWrapper',

    components: {
      'send-button-default': SendButtonDefault,
      'send-button-sibur': SendButtonSibur
    },

    computed: {
      way() {
        let way = 'send-button';

        if (this.$store.getters['invites/creation/hasProcess'](PROCESS_NAMES.SIBUR_TEST)) {
          return `${way}-sibur`;
        }

        return `${way}-default`;
      }
    }
  };
</script>
